import { post } from "@/application/api";
import { AxiosResponse } from "axios";

export const logout = (): Promise<AxiosResponse<void>> => {
  return post("auth/logout");
};
